<!--
 * @Author: DY
 * @Date: 2025-02-17 17:58:46
 * @LastEditTime: 2025-03-04 18:03:44
 * @Description: 客户验收处理【销售管理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\customerAcceptanceProcessing\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="customerAcceptanceProcessing commonListStyles">
            <HeaderNav
                header-title="客户验收处理"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ rightCallBack: openAddForm, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">质量验收单号：{{ item.check_accept_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.approve_status == 0 ? '未提交' : '已提交' }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料代码：{{ item.material_codes }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_names }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>发货数量（吨）：{{ item.delivery_weight }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>签收数量（吨）：{{ item.sign_weight }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" @click="openDetails(item)">
                                            发货明细
                                        </van-button>
                                        <van-button
                                            plain
                                            type="danger"
                                            v-if="item.approve_status == 0"
                                            @click="toDetail(item, 'edit')"
                                        >
                                            办理
                                        </van-button>
                                        <van-button
                                            plain
                                            type="danger"
                                            v-else
                                            @click="toDetail(item, 'view')"
                                        >
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'customer-acceptance-processing',
    mixins: [mixin_list],
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'customer-acceptance-processing');
        }
        next();
    },
    data() {
        return {
            tableCode: 'client_check_accept',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.finished = false;
            this.listData = [];
            this.pageIndex = 0;
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        openDetails(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'customerAcceptanceApprovalForm',
                params: {
                    delivery_notice_id: item.delivery_notice_id,
                    material_codes: item.material_codes,
                },
            });
        },
        openAddForm() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'customerAcceptanceProcessingForm',
                params: {
                    type: 'add',
                },
            });
        },
        toDetail(item, type) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'customerAcceptanceProcessingForm',
                params: {
                    type,
                    id: item.id,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.customerAcceptanceProcessing
    width 100%
    height 100%
    background #F0F0F0
    .content
        width 100%
        height calc(100% - 44rpx)
        >>>.van-search
            background #EAEAEA !important
            height 45rpx !important
        >>>.van-search__content
            background #fff !important
        .btn-con
            display flex
            position fixed
            width 100%
            height 59rpx
            bottom 0
            z-index 0
            background #fff
            padding 10rpx 25rpx
            .btn
                flex 1
                height 39rpx
                text-align center
                line-height 39rpx
                cursor pointer
            .submit-btn
                background #fcebec
                border 1px solid #f9cdcf
                color #ea4b49
                margin-right 18rpx
            .save-btn
                color #fff
                background: linear-gradient(to right, #EB6348, #e93543);
</style>
